import { type ReactNode } from "react"

export function getDefaultHeadlessAppLayout(page: ReactNode) {
    return <>{page}</>
}
